<div class="row post comments" style="margin-left:20px;" *ngFor="let comment of comments;">
  <div class="medium-12">

    <!---Display Sub Comment---->
    <ng-template [ngIf]="updateObj.id !== comment.id">
      <div class="row post-user">
        <div *ngIf="comment.user.firstName !== 'Karlie' && comment.user.thumbnail && comment.user.thumbnail.length > 0" style="float: left;margin-right: 10px;line-height: 37px;">
          <div class="posts-thumbnail" [ngStyle]="{'background': 'url(' + comment.user.thumbnail + ') center center no-repeat'}"></div>
        </div>
        <div class="round" style="float: left;margin-right: 10px;width:35px;height: 35px;line-height: 37px;" [hidden]="comment.user.thumbnail" [style.background-color] = "comment.user.colorCode" *ngIf="comment.user.firstName !== 'Karlie'">
          {{comment.user.firstName.charAt(0)}}{{comment.user.lastName.charAt(0)}}
        </div>
        <div class="round" style="background-color:transparent;float: left;margin-right: 10px;width:35px;height: 35px;line-height: 37px;" *ngIf="comment.user.firstName === 'Karlie'">
          <img src="https://static.taxplaniq.com/futurefirm/favicon_new.png">
        </div>
        <div class="medium-10">
          <span class="user float-left">{{comment.user.firstName}}</span>
          <span class="user float-left" *ngIf="comment.user.firstName !== 'Karlie'">{{comment.user.lastName}}</span>
          <span class="mentioned-users" style="font-size: 14px" *ngIf="comment.mentionIds && comment.mentionIds.length > 0">{{comment.mention_message}}</span>
          <div>
            <pre class="post-pre comment-pre float-left" [innerHTML]="comment.message | linky:{stripPrefix: false}"></pre>
          </div>
        </div>
        <div class="column text-right update-dropdown options-list">
          <ul class="vertical medium-horizontal menu">
            <li class="is-dropdown-submenu-parent opens-left">
              <i class="material-icons pointer more-horiz post_options" aria-hidden="true">more_horiz</i>
              <ul class="vertical post-option-wrapper is-dropdown-submenu" (clickOutside)="hidePostOptions()">
                <li *ngIf="user.id === comment.user.id"><a href="javascript:void (0)" (click)="handleCommentAction('edit',comment,comment.postID)">Edit message</a></li>
                <li *ngIf="user.id === comment.user.id"><a href="javascript:void (0)" (click)="handleCommentAction('delete',comment,comment.postID)">Delete</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="row post-comment" *ngIf="comment.documents.length > 0">
        <div class="column medium-5 attachment" *ngFor="let attachment of comment.documents">
          <div class="row post-uploaded-doc">
            <div class="column medium-9 commonColor2 pointer" style="margin-left: -5px">
              <div class="attachment_name" style="font-weight: 500 !important;color: #16477A !important;">{{attachment.name}}</div>
            </div>
            <div class="column medium-3" style="padding: 0px">
              <i class="icon ion-ios-trash commonColor2" (click)="deleteAttachment(attachment.id, comment)"></i>
            </div>
          </div>
        </div>
        <div class="column medium-6"></div>
      </div>

      <div class="row post-body">
        <div class="column medium-11">
          <span class="likeSeparator likeOptions commonColor1">.</span>
          <span class="likeOptions commonColor1 pointer" (click)="showCommentInput(comment.id)" [ngClass] = "selectedCommentInput === 'comment_'+comment.id ?'commonColor2' : 'commonColor1'">{{selectedCommentInput === 'comment_'+comment.id ? 'Hide' : 'Reply'}}</span>
          <span class="likeSeparator likeOptions commonColor2">.</span>
          <span class="likeOptions commonColor2 post-dateTime-dropdown">
            <span class="display-date">{{comment.displayDate}}</span>
        </span>
        </div>
        <div class="column medium-1 text-right">
        </div>
      </div>

      <section class="upload-area" ng2FileDrop [uploader]="uploader" (onFileDrop)="fileDropOver($event)">
        <div class="row" id="comment_{{comment.id}}" *ngIf="selectedCommentInput === 'comment_'+comment.id" style="background-color: #F6F7F9;padding-bottom:10px;padding-top: 20px;">
          <div class="column medium-12 current-mentions" *ngIf="mentions && mentions.length > 0">
            You are mentioning:
            <span class="mentioned-users">{{mentions}}</span>
          </div>
          <div class="column medium-12">
            <div class="row">
              <div class="column medium-12 postAttachment" style="margin-top:15px;padding: 0 5px 3px !important;" *ngIf="postUploadResp.length > 0">
                <div class="row" *ngFor="let attachment of postUploadResp">
                  <div class="column medium-1"></div>
                  <div class="column medium-3 commonColor2 pointer" attr.title="{{attachment.name}}">
                    <div class="attachment_name">{{attachment.name}}</div>
                  </div>
                  <div class="column medium-1">
                    <i class="icon ion-ios-trash commonColor2" (click)="deleteAttachment(attachment.id)"></i>
                  </div>
                </div>
              </div>
              <div class="column medium-12 postAttachment" *ngIf="documentsData.length>0">
                <div class="row" *ngFor="let document of documentsData">
                  <div class="column medium-1"></div>
                  <div class="column medium-3 commonColor2 pointer" attr.title="{{document['file'].name}}">
                    <div class="attachment_name">{{document['file'].name}}</div>
                  </div>
                  <div class="column medium-1">
                    <i class="icon ion-ios-trash commonColor2" (click)="removeDocument(document)"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="column medium-12">
                <div *ngIf="user.thumbnail && user.thumbnail.length > 0" style="float: left;margin-right: 10px;line-height: 37px;">
                  <div class="posts-thumbnail" [ngStyle]="{'background': 'url(' + user.thumbnail + ') center center no-repeat'}"></div>
                </div>
                <div class="round" style="float: left;margin-right: 10px;width:35px;height: 35px;line-height: 37px;" [hidden]="user.thumbnail" [style.background-color] = "user.colorCode">
                  {{user.first_name.charAt(0)}}{{user.last_name.charAt(0)}}
                </div>
                <div class="inputContainer" style="bottom: 5px;position: relative;">
                  <div style="flex-grow: 1;min-width: 0;word-break: break-word;">
                    <textarea class="direct-text-box new-comment-textarea" autosize placeholder="{{placeHolder}}" [(ngModel)]="subcommentMsg" *ngIf="messageHeight"
                              (keydown.enter)="onSubCommentEnter($event,comment)"></textarea>
                  </div>
                  <div class="inputAttachments">
                    <span class="pointer" (click)="showMentionWidget()">&#64;</span>
                    <div class="zero-right-margin" *ngIf="showMentionDropdown && isQountOrgUser" (clickOutside)="closeMentionContainer()">
                      <app-label-input-search [setData]="mentionUsers" [selectedData]="mentionIds" [displayKey]="'name'" (onLabelSearchSelection)="mentionSelected($event)"
                                              [removeLabelClass] = true (onLabelRemove)="removeMention($event)"></app-label-input-search>
                    </div>
                    <div class="zero-right-margin" *ngIf="showMentionDropdown && !isQountOrgUser" (clickOutside)="closeMentionContainer()">
                      <app-label-input-search [setData]="clientInternalUsers" [selectedData]="mentionIds" [displayKey]="'name'" (onLabelSearchSelection)="mentionSelected($event)"
                                              [removeLabelClass] = true (onLabelRemove)="removeMention($event)"></app-label-input-search>
                    </div>
                    <span class="float-left">
                      <label class="button upload_button">
                        <span (click)="triggerFileUpload(comment)"><i class="material-icons">attach_file</i></span>
                      </label>
                      <input type="file" id="subcomment-{{comment.id}}" (change)="startUpload($event)" value="null" class="show-for-sr" ng2FileSelect [uploader]="uploader" multiple/>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ng-template>

    <!-- Edit comment-->
    <div class="row" id="comment.id" *ngIf="updateObj.id === comment.id" style="background-color: #F6F7F9;padding-bottom:10px;padding-top: 20px;" (keydown.escape)="stopEditing()">
      <div class="column medium-12">
        <div class="row">
          <div class="column medium-12 postAttachment" style="margin-top:15px;padding: 0 5px 3px !important;" *ngIf="updateObj.documentName">
            <div class="row">
              <div class="column medium-1"></div>
              <div class="column medium-3 commonColor2 pointer" attr.title="{{updateObj.documentName}}">
                <div class="attachment_name">{{updateObj.documentName}}</div>
              </div>
              <div class="column medium-1">
                <i class="icon ion-ios-trash commonColor2" (click)="deleteAttachment(updateObj.id, updateObj)"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="column medium-12">
            <div *ngIf="updateObj.user.thumbnail && updateObj.user.thumbnail.length > 0" style="float: left;margin-right: 10px;line-height: 37px;">
              <div class="posts-thumbnail" [ngStyle]="{'background': 'url(' + updateObj.user.thumbnail + ') center center no-repeat'}"></div>
            </div>
            <div class="round" style="float: left;margin-right: 10px;width:35px;height: 35px;line-height: 37px;" [hidden]="updateObj.user.thumbnail" [style.background-color] = "updateObj.user.colorCode">
              {{updateObj.user.firstName.charAt(0)}}{{updateObj.user.lastName.charAt(0)}}
            </div>
            <div class="inputContainer" style="bottom: 5px;position: relative;">
              <div style="flex-grow: 1;min-width: 0;word-break: break-word;">
                <textarea class="direct-text-box new-comment-textarea" autosize placeholder="{{placeHolder}}" [(ngModel)]="updateObj.message" [isEditComment]="true"
                          (keydown.enter)="onUpdateEnter('comment')"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row post-body pointer" *ngIf="selectedCommentToggle !== 'commentToggle'+comment.id">
      <div class="column medium-11">
        <div id="commentToggle{{comment.id}}" *ngIf="comment.children.length>0" (click)="showCommentToggle(comment.id)">
          <i class="fa fa-reply" style="transform: rotate(180deg);font-size: 10px;"></i>
          <span>View </span><span>{{comment.children.length}}</span>
          <span *ngIf="comment.children.length > 1"> replies</span>
          <span *ngIf="comment.children.length === 1">reply</span>
        </div>
      </div>
    </div>
    <div class="row post-body pointer" *ngIf="selectedCommentToggle === 'commentToggle'+comment.id">
      <div class="column medium-11">
        <div id="commentToggle{{comment.id}}" *ngIf="comment.children.length>0" (click)="showCommentToggle(comment.id)">
          <i class="fa fa-chevron-up" style="font-size: 10px;"></i>
          <span>Hide </span>
          <span>{{comment.children.length}} </span>
          <span *ngIf="comment.children.length > 1">replies</span>
          <span *ngIf="comment.children.length === 1">reply</span>
        </div>
      </div>
    </div>
    <app-sub-comment [data]="comment.children" [pageType]="pageType" [taskId]="taskId" [companyId]="companyId" *ngIf="comment.children.length>0" [hidden]="selectedCommentToggle !== 'commentToggle'+comment.id" id="commentToggle{{comment.id}}"></app-sub-comment>
  </div>
</div>
